import { Avatar, Box, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";

const avatarSrc =
  "https://images.unsplash.com/photo-1639634121331-cd7ea0c6cc1a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=871&q=80";

const Footer = () => {
  return (
    <Box
      bgColor={"blackAlpha.900"}
      color={"whiteAlpha.700"}
      minH={"48"}
      px={"16"}
      py={["16", "8"]}
    >
      <Stack direction={["column", "row"]} h={"full"} alignItems={"center"}>
        <VStack w={"full"} alignItems={["center", "flex-start"]}>
          <Text fontWeight={"bold"} fontSize={"lg"} mb={2}>
            About Us
          </Text>
          <Text fontSize={"sm"} textAlign={["center", "left"]}>
            We are the best crypto trading app in India, providing guidance at an affordable price.
          </Text>
        </VStack>

        <VStack alignItems={["center", "flex-start"]} spacing={4}>
          <Avatar size={"lg"} src={avatarSrc} />
          <Text fontSize={"lg"}>Welcome</Text>
        </VStack>
      </Stack>
    </Box>
  );
};

export default Footer;
